/** Secondary-nav model for the Consulting → Billing & Time dashboard. */
export interface BillingTimeItem {
  label: string;
  icon: string;
  path: string;
}
export interface BillingTimeSection {
  title: string;
  items: BillingTimeItem[];
}

const base = '/consulting/billing-time';

/** Grouped sub-navigation (mirrors the time-tracking reference: Track / Analyze / Manage). */
export const BILLING_TIME_NAV: BillingTimeSection[] = [
  {
    title: 'Track',
    items: [
      { label: 'Overview', icon: 'ph-squares-four', path: `${base}/overview` },
      { label: 'Timer', icon: 'ph-timer', path: `${base}/timer` },
    ],
  },
  {
    title: 'Analyze',
    items: [
      { label: 'Reports', icon: 'ph-chart-bar', path: `${base}/reports` },
      { label: 'Approvals', icon: 'ph-check-circle', path: `${base}/approvals` },
    ],
  },
  {
    title: 'Manage',
    items: [
      { label: 'Projects', icon: 'ph-folders', path: `${base}/projects` },
      { label: 'Clients', icon: 'ph-identification-card', path: `${base}/clients` },
      { label: 'Team', icon: 'ph-users-three', path: `${base}/team` },
      { label: 'Billable rates', icon: 'ph-currency-circle-dollar', path: `${base}/billable-rates` },
      { label: 'Invoices', icon: 'ph-receipt', path: `${base}/invoices` },
      { label: 'Tags', icon: 'ph-tag', path: `${base}/tags` },
      { label: 'Goals', icon: 'ph-flag', path: `${base}/goals` },
    ],
  },
];

/** Flat list of every item (handy for generating routes). */
export const BILLING_TIME_ITEMS: BillingTimeItem[] = BILLING_TIME_NAV.flatMap((s) => s.items);
